import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import ForgotPasswordFormCard from '../../components/authentication/ForgotPasswordFormCard';
import ForgotPasswordEmailSentCard from '../../components/authentication/ForgotPasswordEmailSentCard';

export default function ForgotPasswordPage() {
  const location = useLocation();
  const initialEmail = (location.state as { email?: string } | null)?.email ?? '';

  const [sent, setSent] = useState(false);
  const [submittedEmail, setSubmittedEmail] = useState('');

  if (sent) {
    return (
      <ForgotPasswordEmailSentCard
        email={submittedEmail}
        onChangeEmail={() => setSent(false)}
      />
    );
  }

  return (
    <ForgotPasswordFormCard
      initialEmail={initialEmail}
      onSent={(email) => { setSubmittedEmail(email); setSent(true); }}
    />
  );
}
